// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/adverse-yaw.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/adverse-yaw/adverse-yaw.js';

mount([g0]);
